export default __webpack_public_path__ + "static/media/cfjp01.ab90a665.png";